'use client';

import { ListboxSeparator } from "../../utils/listbox-separator/ListboxSeparator.mjs";
/**
 * A visual separator between items or groups.
 * Renders a `<div>` element.
 *
 * Documentation: [Base UI Select](https://base-ui.com/react/components/select)
 */
export const SelectSeparator = ListboxSeparator;